import { queryOptions } from "@tanstack/react-query";

import { api } from "./api";
import type { Role, User } from "./auth";

export interface Paginated<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const usersQueryKey = ["users"] as const;

export const usersQueryOptions = queryOptions({
  queryKey: usersQueryKey,
  queryFn: () => api<Paginated<User>>("/users/?page_size=500"),
});

export interface CreateUserInput {
  email: string;
  first_name: string;
  last_name: string;
  role: Role;
  password: string;
}

export type UpdateUserInput = Partial<
  Pick<User, "email" | "first_name" | "last_name" | "role" | "is_active">
>;

export const usersApi = {
  create: (input: CreateUserInput) => api<User>("/users/", { method: "POST", body: input }),
  update: (id: string, input: UpdateUserInput) =>
    api<User>(`/users/${id}/`, { method: "PATCH", body: input }),
  setPassword: (id: string, newPassword: string) =>
    api<void>(`/users/${id}/set-password/`, {
      method: "POST",
      body: { new_password: newPassword },
    }),
};

export const accountApi = {
  updateProfile: (input: { first_name: string; last_name: string }) =>
    api<User>("/auth/me/", { method: "PATCH", body: input }),
  changePassword: (input: { current_password: string; new_password: string }) =>
    api<void>("/auth/password/", { method: "POST", body: input }),
};
